<template>

	<v-layout row wrap v-if="error !== ''" style="color: #ff153c; padding-bottom: 1px">
		<v-flex d-flex xs12>
			<v-card color="red" dark>
				<v-card-text>
					<v-icon>error</v-icon>
					<strong>
						<b>
							{{error}}
						</b>
					</strong>
				</v-card-text>
			</v-card>
		</v-flex>
	</v-layout>

</template>

<script>
	export default {
		name: "egrantyValidationError",

		props: {
			error: String
		},
	};
</script>

<style scoped>

</style>